import can from 'can';
import $ from 'jquery';
import dayjs from 'dayjs';
import utc from'dayjs/plugin/utc';
import timezone from'dayjs/plugin/timezone';

dayjs.extend(utc)
dayjs.extend(timezone);

const ua = window.navigator.userAgent.toLowerCase();
const appName = window.navigator.appName;

const checkIE = function () {
	let re;
	let rv = false;
	if (appName == 'Microsoft Internet Explorer') {
		re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})', 'i');
		if (!!re.exec(ua)) {
			rv = parseFloat(RegExp.$1);
		}
	}
	else if (appName == 'Netscape') {
		re = new RegExp('Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})', 'i');
		if (!!re.exec(ua)) {
			rv = parseFloat(RegExp.$1);
		}
	}
	return rv;
};

const checkSafari = function () {
	return /^((?!chrome).)*safari/i.test(ua);
};

const isTouchAvailable = function () {
	let isAvailable = 'ontouchstart' in window;

	// on some versions and configurations of IE on desktop touch feature is detected not correctly
	if (window.navigator.msPointerEnabled) {
		// desktop will not have touch points
		isAvailable = (navigator.msMaxTouchPoints > 0);
	}
	return isAvailable;
};

const getUrlHash = function () {
	return can.deparam(document.location.hash.substr(1));
};

const createUrlHash = function (params) {
	let hash = '#';

	if (usgaUtils.isObject(params)) {
		hash = hash.concat(can.param(params));
	}
	return hash;
};

const shortUrl = function (url, limit) {
	if (url) {
		let shortUrl = '' + url;

		limit = limit || 30;
		shortUrl = shortUrl
			.replace(/^(?:[^\:]+\:\/\/)*(.*)$/, '$1') // cuts proto
			.replace(/(\/|#|\?)*$/, '');
		if (shortUrl.length > limit) {
			shortUrl = (shortUrl.substr(0, limit) + '...').replace(/(\?|#|\/)\.\.\./, '...');
		}
		return shortUrl;
	}
	return '';
};

const trimHostFromUrl = function (url) {
	if (url) {
		url = url
			.replace(/^(?:[^\:]+\:\/\/)*(.*)$/, '$1')
			.replace(location.host, '')
			.replace(/^\/+/, '\/');

		return url;
	}
	return url;
};

export const usgaUtils = {
	$: $,
	domReady: false,
	windowLoad: false,
	isStandalone: (('standalone' in window.navigator) &&
		window.navigator.standalone === true) || window.location.hash.indexOf('#standalone') !== -1 ||
	window.location.search.indexOf('standalone=true') !== -1,
	device: {
		ios: ua.match(/i(pod|pad|phone)/i),
		android: ua.match(/android/i),
		mobile: ua.search(/(i(pod|pad|phone)|android)/i) !== -1
	},
	browser: {
		ie: checkIE(),
		safari: checkSafari()
	},
	supports: {
		touch: isTouchAvailable()
	},
	url: {
		query: can.deparam(document.location.search.substr(1)),
		getHash: getUrlHash,
		createHash: createUrlHash,
		short: shortUrl,
		trimHost: trimHostFromUrl
	},
	setDtm: function (props) {
		window.digitalData = window.digitalData || {};
		window.digitalData = $.extend(true, window.digitalData, props);
	},
	trackDtm: function (event, props, onDtmTrack) {
		if (window._satellite) {
			this.setDtm(props);
			window._satellite.track(event);
			if ($.isFunction(onDtmTrack)) {
				setTimeout(function () {
					onDtmTrack(event, props, window.digitalData);
				}, 1000);
			}
		}
	},
	log: function () {
		const console = window.console;
		if (console && typeof console.log === 'function') {
			console.log.apply(console, arguments);
		}
	},
	getArgs: function (args, start, count) {
		start = start || 0;
		const end = count ? start + count : args.length;
		return Array.prototype.slice.call(args, start, end);
	},
	cutText: function (text, len, appendix) {
		if (!text || text === null) {
			text = '';
		}
		text = '' + text;
		if (!len || isNaN(+len) || +len < 1) {
			len = 80;
		}
		if (appendix === undefined) {
			appendix = ' ...';
		}
		if (text.length <= len) {
			return text;
		}

		let cutText = text.substr(0, len + 1);
		const lastDelimIndex = cutText.lastIndexOf(' ');

		if (lastDelimIndex >= 0) {
			cutText = cutText.substr(0, lastDelimIndex);
		}

		if (cutText) {
			cutText += appendix;
		}

		return cutText;
	},
	quote: function (text) {
		return text.replace('\\', '\\\\').replace('\'', '\\\'');
	},
	stripTags: function (text) {
		if (false === (text && typeof text === 'string')) {
			text = text ? '' + text : '';
		}
		return text.replace(/<[^>]+>/ig, '');
	},
	trimDamInUrl: function (url) {
		if (false === (url && typeof url === 'string')) {
			url = url ? '' + url : '';
		}

		return url.replace(/^\/*content\/dam\/*/, '');
	},
	getMomentInNewYorkTimezone: function (date) {
		if (!date || !dayjs(date).isValid()) {
			return dayjs().tz('America/New_York');
		}
		return dayjs(new Date(date)).tz('America/New_York');
	},
	isDefined: function (val) {
		return val !== undefined && val !== null;
	},
	isObject: function (obj) {
		const type = typeof obj;

		return type === 'function' || type === 'object' && !!obj;
	},
	keys: function (obj) {
		if (!usgaUtils.isObject(obj)) {
			return [];
		}
		if (Object.keys) {
			return Object.keys(obj);
		}

		const keys = [];

		for (let key in obj) {
			if (usgaUtils.has(obj, key)) {
				keys.push(key);
			}
		}

		return keys;
	},
	values: function (obj) {
		const keys = usgaUtils.keys(obj),
			length = keys.length,
			values = Array(length);

		for (let i = 0; i < length; i++) {
			values[i] = obj[keys[i]];
		}

		return values;
	},
	findWhere: function (items, properties) {
		let found = false;

		if (!usgaUtils.isObject(properties)) {
			properties = {};
		}

		if ($.isArray(items)) {
			$.each(items, function (index, item) {
				const obj = item;
				let result = true;

				if (!usgaUtils.isObject(obj)) {
					return true;
				}

				const keys = usgaUtils.keys(properties),
					length = keys.length;

				for (let i = 0; i < length; i++) {
					const key = keys[i].replace(/^\!/, ''),
						testKey = keys[i];
					let negative = false;

					if (testKey.substr(0, 1) === '!') {
						negative = true;
					}

					if (negative) {
						result = $.isArray(properties[testKey]) ? $.inArray(obj[key], properties[testKey]) === -1 :
							obj[key] !== properties[testKey];
					}
					else {
						result = obj[key] !== undefined && ($.isArray(properties[testKey]) ? $.inArray(obj[key], properties[testKey]) !== -1 :
							obj[key] === properties[key]);
					}
				}

				if (result) {
					found = index;
					return false;
				}
			});
		}

		return found;
	},
	has: function (obj, key) {
		return obj !== null && hasOwnProperty.call(obj, key);
	},
	reduce: function (array, callback, initialValue) {
		if (this === null) {
			return initialValue;
		}
		if (typeof callback !== 'function') {
			return initialValue;
		}

		const t = usgaUtils.values(array),
			len = t.length >>> 0;
		let k = 0,
			value = initialValue;

		for (; k < len; k++) {
			if (k in t) {
				value = callback(value, t[k]);
			}
		}
		return value;
	},
	sum: function (array) {
		return usgaUtils.reduce(array, function (p, v) {
			return p + v;
		}, 0);
	},
	replaceURLWithHTMLLinks: function (text, newWindow) {
		const exp = /(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/ig;
		let template = '<a href="$1">$1</a>';

		if (newWindow) {
			template = '<a href="$1" target="_blank">$1</a>';
		}

		return text.replace(exp, template);
	},

	replaceTwitterUsernameWithHTMLLinks: function (text, newWindow) {
		const exp = /(^|\s)@([a-z0-9_]+)/ig;
		let template = '$1<a href="http://www.twitter.com/$2">@$2</a>';

		if (newWindow) {
			template = '$1<a href="http://www.twitter.com/$2" target="_blank">@$2</a>';
		}

		return text.replace(exp, template);
	},

	replaceHashtagsWithHTMLLinks: function (text, newWindow, network) {
		const exp = /(^|\s)#([a-z0-9_]+)/ig,
			socialUrl = network === 'twitter' ? 'http://www.twitter.com/search?q=$2' : 'https://www.facebook.com/hashtag/$2';
		let template = '$1<a href="' + socialUrl + '">#$2</a>';

		if (newWindow) {
			template = '$1<a href="' + socialUrl + '" target="_blank">#$2</a>';
		}

		return text.replace(exp, template);
	},
	centerElementVertically: function (element) {
		const elHeight = element.height(),
			viewHeight = $(window).height();

		if (elHeight < viewHeight) {
			element.css('position', Math.ceil(viewHeight / 2 - elHeight / 2));
		}
		else {
			element.css('position', '0');
		}
	},
	scrollTo: function (element, speed) {
		const $element = $(element);
		if ($element.length) {
			speed = speed || 500;
			const top = $element.offset().top;
			$('html, body').animate({scrollTop: top}, speed);
		}
	}
};

const $html = $('html');

if (usgaUtils.browser.ie) {
	$html.addClass('ie ie' + usgaUtils.browser.ie);
}

if (usgaUtils.device.ios) {
	$html.addClass('ios');
}

if (usgaUtils.supports.touch) {
	$html.addClass('touch');
}
else {
	$html.addClass('no-touch');
}

if (usgaUtils.device.android) {
	if (!usgaUtils.isStandalone) {
		if (window.localStorage.getItem('webapp-client-width')) {
			if (screen.width - document.documentElement.clientHeight <
				window.localStorage.getItem('webapp-client-width') ||
				screen.height - document.documentElement.clientHeight <
				window.localStorage.getItem('webapp-client-height')
			) {
				usgaUtils.isStandalone = true;
			}
		}
		else {
			window.localStorage.setItem('webapp-client-width', screen.width - document.documentElement.clientHeight);
			window.localStorage.setItem('webapp-client-height', screen.height - document.documentElement.clientHeight);
		}
	}
}

$(function () {
	usgaUtils.domReady = true;
});

$(window).load(function () {
	usgaUtils.windowLoad = true;
});


